import type { ImportBudget, ImportProject } from "@/types/Import";

export const convertImportColumnToIndex = (col: string): number => {
  return col.trim() === "" ? -1 : col.trim().charCodeAt(0) - 65;
};

export const setProjectImportInfo = (info: ImportProject, data: any) => {
  info.projectIdTab = data.projectIdTab;
  info.projectIdCol = convertImportColumnToIndex(data.projectIdCol);
  info.projectIdRow = data.projectIdRow;

  info.projectNameTab = data.projectNameTab;
  info.projectNameCol = convertImportColumnToIndex(data.projectNameCol);
  info.projectNameRow = data.projectNameRow;

  info.projectAddressTab = data.projectAddressTab;
  info.projectAddressCol = convertImportColumnToIndex(data.projectAddressCol);
  info.projectAddressRow = data.projectAddressRow;

  info.projectNotesTab = data.projectNotesTab;
  info.projectNotesCol = convertImportColumnToIndex(data.projectNotesCol);
  info.projectNotesRow = data.projectNotesRow;

  info.initialLenderFundsTab = data.initialLenderFundsTab;
  info.initialLenderFundsCol = convertImportColumnToIndex(data.initialLenderFundsCol);
  info.initialLenderFundsRow = data.initialLenderFundsRow;

  info.adjustedLenderFundsTab = data.adjustedLenderFundsTab;
  info.adjustedLenderFundsCol = convertImportColumnToIndex(data.adjustedLenderFundsCol);
  info.adjustedLenderFundsRow = data.adjustedLenderFundsRow;

  info.initialOtherEquityTab = data.initialOtherEquityTab;
  info.initialOtherEquityCol = convertImportColumnToIndex(data.initialOtherEquityCol);
  info.initialOtherEquityRow = data.initialOtherEquityRow;

  info.adjustedOtherEquityTab = data.adjustedOtherEquityTab;
  info.adjustedOtherEquityCol = convertImportColumnToIndex(data.adjustedOtherEquityCol);
  info.adjustedOtherEquityRow = data.adjustedOtherEquityRow;
};

export const setBudgetImportInfo = (info: ImportBudget, data: any) => {
  info.lineRefCol = convertImportColumnToIndex(data.lineRefCol);
  info.descriptionCol = convertImportColumnToIndex(data.descriptionCol);
  info.budgetAmtCol = convertImportColumnToIndex(data.budgetAmtCol);
  info.initBudgetAmtCol = convertImportColumnToIndex(data.initBudgetAmtCol);
  info.priorDrawnToDateCol = convertImportColumnToIndex(data.priorDrawnToDateCol);
  info.thisDrawAmtCol = convertImportColumnToIndex(data.thisDrawAmtCol);
  info.priorEquityDrawnToDateCol = convertImportColumnToIndex(data.priorEquityDrawnToDateCol);
  info.thisEquityDrawAmtCol = convertImportColumnToIndex(data.thisEquityDrawAmtCol);
  info.inspPriorDrawCol = convertImportColumnToIndex(data.inspPriorDrawCol);
  info.inspThisDrawCol = convertImportColumnToIndex(data.inspThisDrawCol);
};
